module.exports = __webpack_public_path__ + "6705c6872ad82e89aa5300a81b9c82e4.svg";